import moment from "../../moment";

// Pass・Sheet共有で使いそうな処理
export default {
  checkIsAvailablePeriod(started_at, limited_at) {
    var current = moment(new Date());
    var start = moment(new Date(started_at));
    var limit = moment(new Date(limited_at));

    return start.isBefore(current) && limit.isAfter(current);
  },

  checkPassIsAvailablePeriod(pass) {
    let isUsingPeriod = true;
    if (
      pass.using_window != null &&
      pass.using_window.length > 0 &&
      pass.using_window[0].using_started_at != null &&
      pass.using_window[0].using_limited_at != null
    ) {
      isUsingPeriod = this.checkIsAvailablePeriod(
        pass.using_window[0].using_started_at,
        pass.using_window[0].using_limited_at
      );
    }

    return isUsingPeriod;
  },

  getCountDown(limited_at) {
    var current = moment(new Date());
    var limit = moment(new Date(limited_at));

    // limitと現在時刻の時差を算出して文字列にする
    var duration = moment.duration(limit.diff(current));
    var days = duration.days(),
      hrs = duration.hours(),
      mins = duration.minutes(),
      secs = duration.seconds();

    var format = "00:00:00:00";

    // 差分がマイナスの場合は、00:00:00:00のままで返す
    if (!(days <= 0 && hrs <= 0 && mins <= 0 && secs <= 0)) {
      days < 10 ? (days = "0" + days) : days;
      hrs < 10 ? (hrs = "0" + hrs) : hrs;
      mins < 10 ? (mins = "0" + mins) : mins;
      secs < 10 ? (secs = "0" + secs) : secs;
      format = days + ":" + hrs + ":" + mins + ":" + secs;
    }

    return format;
  },

  /// 有効期間の終了日時
  getDiffLimitedAtMinusStartHour(limited_at, start_hour) {
    // start_hourは数値が入ってくる
    if (start_hour != null) {
      return moment(new Date(limited_at)).subtract(start_hour, "h").format();
    } else {
      // start_hourがnullの場合はlimited_atを整形するのみで返す
      return moment(new Date(limited_at));
    }
  },

  checkIsBeforeEndTime(book) {
    const endTime =
      book.user_limited_at != null
        ? book.user_limited_at
        : book.available_limited_at;
    const current = moment(new Date());
    return current.isBefore(new Date(endTime));
  },

  /// sheetのカウントダウン計算用のlimit
  getCountDownLimit(stamped_at, faceCountDown) {
    if (faceCountDown == null) return moment(new Date(stamped_at));

    // faceCountDown: X minutes(分単位)
    var countDown = faceCountDown.replace(/[^0-9]/g, "");
    return moment(new Date(stamped_at)).add(countDown, "m").format();
  },
};
